import { configureStore } from '@reduxjs/toolkit';
import { timumApiSlice } from '@timum/timum_pdk';
import appStateReducer from '../slices/appState';

export function createStore(instanceId) {
  return configureStore({
    reducer: {
      [timumApiSlice.reducerPath]: timumApiSlice.reducer,
      appState: appStateReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(timumApiSlice.middleware),
    preloadedState: {
      appState: { isWaitingForConf: true, instanceId },
    },
    devTools: { trace: true },
  });
}

// Default singleton for backward compatibility (iframe paths, single-instance usage)
export default createStore('default');
